<!--suppress TypeScriptUnresolvedFunction -->
<div fxLayout="column" class="bacnet-config-container">
    <div fxLayout="row" fxLayoutAlign="center" class="mb-16">
        <span>{{'Type'|i18n}}: <strong>{{cfg.type|connectorType}}</strong></span>
    </div>
    <div fxLayout="row" fxLayoutAlign="center">
        <form novalidate [formGroup]="form" fxLayout="column" fxLayoutGap="0.5rem" fxFlex="50" class="bacnet-form">
            <mat-form-field>
                <input matInput placeholder="{{'Host'|i18n}}" formControlName="host">
                <mat-error *ngIf="!form.controls.host.valid">
                    {{'Invalid host'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput placeholder="{{'BBDM'|i18n}}" formControlName="bbdm">
                <mat-error *ngIf="!form.controls.bbdm.valid">
                    {{'Invalid BBDM'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput placeholder="{{'TTL'|i18n}}" formControlName="ttl" type="number">
                <mat-error *ngIf="!form.controls.ttl.valid">
                    {{'Invalid TTL'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <app-divider class="mt-8 mb-8" gap="0.5rem">{{'BACnet devices'|i18n}}</app-divider>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-8">
        <button mat-stroked-button color="primary" class="add-bacnet-device-button"
                (click)="onClickAddBacnetDevice()">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add BACnet device'|i18n}}
        </button>
    </div>
    <div fxLayout="column" fxLayoutGap="8px" class="mt-16">
        <ng-container *appVar="pagedBacnetDevs|async as bacnetDevs">
            <ng-container *ngIf="bacnetDevs">
                <div *ngFor="let bacnetDev of bacnetDevs.data; trackBy: trackByBacnetDevId"
                     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1.5rem">
                    <div fxLayoutAlign="end" fxFlex="grow">
                        <em>{{bacnetDev.bacnetDevId}}</em>
                    </div>
                    <form novalidate [formGroup]="bacnetDev.form" fxLayoutAlign="center" fxFlex="shrink"
                          fxLayoutGap="0.5rem">
                        <mat-form-field>
                            <input matInput placeholder="{{'Address'|i18n}}" formControlName="address">
                            <mat-error *ngIf="!bacnetDev.form.controls.address.valid">
                                {{'Invalid address'|i18n}}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="{{'Id'|i18n}}" formControlName="id" type="number">
                            <mat-error *ngIf="!bacnetDev.form.controls.id.valid">
                                {{'Invalid id'|i18n}}
                            </mat-error>
                        </mat-form-field>
                    </form>
                    <div fxLayoutAlign="start" fxFlex="grow" fxLayoutGap="0.5rem">
                        <button class="operation-button" [title]="'Rename BACnet device'|i18n"
                                (click)="onClickRenameBacnetDevice(bacnetDev.bacnetDevId)">
                            <app-icon name="fal-edit"></app-icon>
                        </button>
                        <button class="operation-button warn" [title]="'Remove BACnet device'|i18n"
                                (click)="onClickDeleteBacnetDevice(bacnetDev.bacnetDevId)">
                            <app-icon name="fal-trash-alt"></app-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
            <mat-paginator #bacnetDevsPaginator app-paginator class="bacnet-paginator"
                           [ngClass]="{'collapsed': !bacnetDevs || bacnetDevs.total === 0}"
                           [length]="bacnetDevs?.total" [pageSize]="PAGE_SIZE"
                           [pageSizeOptions]="PAGE_SIZES">
            </mat-paginator>
        </ng-container>
    </div>
    <app-divider class="mt-8 mb-8" gap="0.5rem">{{'Devices'|i18n}}</app-divider>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-8">
        <button mat-stroked-button color="primary" class="add-device-button"
                (click)="onClickAddDevice()">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add device'|i18n}}
        </button>
    </div>
    <div fxLayout="column" fxLayoutGap="8px" class="mt-16">
        <ng-container *appVar="pagedDevs|async as devs">
            <ng-container *ngIf="devs">
                <div *ngFor="let dev of devs.data; trackBy: trackByDevId"
                     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1.5rem">
                    <div fxLayoutAlign="end" fxFlex="grow">
                        <em>{{dev.devId}}</em>
                    </div>
                    <div fxLayoutAlign="center" fxFlex="shrink" fxLayoutGap="0.5rem">
                        <form novalidate [formGroup]="dev.form" fxLayoutGap="0.5rem" class="device-form">
                            <mat-form-field fxFlex="grow">
                                <mat-select placeholder="{{'BACnet device'|i18n}}" formControlName="bacnetDevId">
                                    <mat-option *ngFor="let bacnetDev of bacnetDevices; trackBy: trackByBacnetDevId"
                                                [value]="bacnetDev.bacnetDevId">
                                        {{bacnetDev.bacnetDevId}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="!dev.form.controls.bacnetDevId.valid">
                                    {{'Invalid BACnet device'|i18n}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field fxFlex="grow">
                                <input matInput placeholder="{{'Point'|i18n}}" formControlName="point"
                                       [title]="'Multiple points are comma-separated'|i18n">
                                <mat-error *ngIf="dev.form.controls.point.hasError('empty')">
                                    {{'Invalid point'|i18n}}
                                </mat-error>
                                <mat-error *ngIf="dev.form.controls.point.hasError('bad_expression')">
                                    {{'Multiple points need expression'|i18n}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="uom-field">
                                <input matInput placeholder="{{'UoM'|i18n}}" formControlName="uom"
                                       [title]="'Unit of measure'|i18n">
                                <mat-error *ngIf="!dev.form.controls.uom.valid">
                                    {{'Invalid UoM'|i18n}}
                                </mat-error>
                            </mat-form-field>
                        </form>
                        <div fxFlexAlign="center">
                            <button mat-stroked-button class="polling-policy-btn" [title]="'Polling policy'|i18n"
                                    (click)="onClickDevicePollingPolicy(dev.devId)">
                        <span class="polling-policy-text">
                            <app-icon name="fal-stopwatch"></app-icon>&nbsp;
                            {{cfg.devices[dev.devId]|pollingPolicy}}
                        </span>
                            </button>
                        </div>
                    </div>
                    <div fxLayoutAlign="start" fxFlex="grow" fxLayoutGap="0.5rem">
                        <button class="operation-button" [title]="'Advanced settings'|i18n"
                                (click)="onClickDeviceAdvancedSettings(dev)">
                            <app-icon name="fal-tools"></app-icon>
                        </button>
                        <button class="operation-button" [title]="'Rename device'|i18n"
                                (click)="onClickRenameDevice(dev.devId)">
                            <app-icon name="fal-edit"></app-icon>
                        </button>
                        <button class="operation-button warn" [title]="'Remove device'|i18n"
                                (click)="onClickDeleteDevice(dev.devId)">
                            <app-icon name="fal-trash-alt"></app-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
            <mat-paginator #devsPaginator app-paginator class="bacnet-paginator"
                           [ngClass]="{'collapsed': !devs || devs.total === 0}"
                           [length]="devs?.total" [pageSize]="PAGE_SIZE"
                           [pageSizeOptions]="PAGE_SIZES">
            </mat-paginator>
        </ng-container>
    </div>
</div>

<ng-template #addBacnetDevice let-data>
    <h1 mat-dialog-title>{{'Add BACnet device'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameBacnetDevice let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['bacnetDevId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="rename-bacnet-device">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
        <span *ngIf="data['connectedDevs'].length" class="connected-devs">
            {{'Devices connected to {0}'|i18n:data['bacnetDevId']}}:
            {{(data['connectedDevs']|sortArray).join(', ')}}
        </span>
        <span *ngIf="!data['connectedDevs'].length" class="connected-devs">
            {{'No devices connected to {0}'|i18n:data['bacnetDevId']}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteBacnetDevice let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['bacnetDevId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="delete-bacnet-device">
        <span>{{'Are you sure you want to delete {0}?'|i18n:data['bacnetDevId']}}</span>
        <span *ngIf="data['connectedDevs'].length" class="connected-devs mt-16">
            {{'Devices connected to {0}'|i18n:data['bacnetDevId']}}:
            {{(data['connectedDevs']|sortArray).join(', ')}}
        </span>
        <span *ngIf="!data['connectedDevs'].length" class="connected-devs mt-16">
            {{'No devices connected to {0}'|i18n:data['bacnetDevId']}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #addDevice let-data>
    <h1 mat-dialog-title>{{'Add device'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameDevice let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field>
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteDevice let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span>{{'Are you sure you want to delete {0}?'|i18n:data['devId']}}</span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #advancedDeviceSettings let-data>
    <h1 mat-dialog-title>{{'Advanced settings for {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="advanced-settings">
        <form novalidate [formGroup]="data['form']" fxLayout="column">
            <span class="expression-label">
                {{'Expression'|i18n}}
            </span>
            <app-expression-editor formControlName="expression"
                                   [features]="data['features']">
            </app-expression-editor>
            <span *ngIf="data['form'].controls.expression.hasError('bad_expression')" class="expression-error">
                {{'Invalid expression for multi-point device'|i18n}}
            </span>
        </form>
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1rem" class="mt-8">
            <span *ngIf="data['points'].length" class="points">
                {{'Points'|i18n}}: {{data['points'].join(', ')}}
            </span>
            <app-icon name="fal-question-circle" class="expression-help"
                      [matTooltip]="EXPRESSION_HELP|i18n"
                      matTooltipClass="fs-1">
            </app-icon>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data.form.valid || !data.form.dirty"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>
